import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import suffixInputField from 'shared/forms/SuffixInputField';
import { formSelect, normalizeRenderedSelect } from 'shared/forms/RenderSelect';
import Button from 'shared/components/Button';
import { toggleHubspotChat } from 'shared/utils/common';

import { required } from 'shared/forms/validators';

import { requestClaimCompany } from 'shared/components/ClaimCompanyModal/ducks';

import './styles.scss';

class ClaimCompanyForm extends React.Component {
  submit = data => {
    const { company } = this.props;

    const submitData = {
      ...data,
      work_email: `${data.work_email}@${company.domain}`,
      membership_type: normalizeRenderedSelect(data.membership_type, false)
    };

    this.props.requestClaimCompany(
      company.slug,
      submitData,
      company.companyType
    );
  };
  render() {
    const { company, membershipTypes, closeModal } = this.props;

    return (
      <form
        className="claim-company-form"
        onSubmit={this.props.handleSubmit(this.submit)}>
        <div className="form-group">
          <label className="form-label">Email address</label>
          <Field
            name="work_email"
            suffix={`@${company.domain}`}
            component={suffixInputField}
            validate={[required]}
          />
          <div
            className="claim-company-help-label"
            onClick={() => {
              toggleHubspotChat();
              closeModal();
            }}>
            I don't have a {company.domain} email address
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">
            How are you associated with {company.name}?
          </label>
          <Field
            name="membership_type"
            component={formSelect}
            isMulti={false}
            options={membershipTypes}
          />
        </div>
        <Button
          color="primary"
          type="submit"
          className="join-btn"
          disabled={this.props.pristine}>
          Join {company.name}
        </Button>
      </form>
    );
  }
}

ClaimCompanyForm = reduxForm({ form: 'claimCompanyForm' })(ClaimCompanyForm);

const mapStateToProps = state => {
  const { constants } = state.constants;

  return {
    membershipTypes: constants.users.MEMBERSHIP_TYPE_CHOICES
  };
};

const mapDispatchToProps = {
  requestClaimCompany
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClaimCompanyForm);
